
export class AuthRoles {
    public static WEBSITE: string = 'Website';
    public static WEBSITE_NORMAL: string = 'Website_Normal';
    public static WEBSITE_ADMIN: string = 'Website_Admin';
    
    public static WEBSITE_SHOPIFY: string = 'Website_Shopify';
    public static WEBSITE_LIGHTSPEED: string = 'Website_Lightspeed';

    public static SYSTEM: string = 'System';
    public static SYSTEM_NORMAL: string = 'System_Normal';
    public static SYSTEM_ADMIN: string = 'System_Admin';
}